import React from "react";

export interface ActivityItem {
  id: string;
  label: string;
  src: string;
}

interface ActivityItemProps {
  activityItem: ActivityItem;
}

export const ActivityItem: React.FC<ActivityItemProps> = (props) => {
  const { activityItem } = props;
  return <img src={activityItem.src} alt={activityItem.label} />;
};
